
export class TitleAndContent {
  title: Map<string, string>;
  content: Map<string, string>;
  constructor() {
    this.title = new Map();
    this.content = new Map();
  }
}
